import { Spinner } from '@/components/Spinner';
import { ManageChargeSubCategoryForm } from './ManageChargeSubCategory';
import { useSubCategoryDetail } from './hooks/useGetSubcategoryList';

export const ManageChargeSubCategoryContainer = ({
  categoryId,
  agentType,
  chargeSubCategoryId,
}: {
  categoryId?: string;
  agentType?: string;
  chargeSubCategoryId?: string;
}) => {
  const { subCategoryDetail, isLoading } = useSubCategoryDetail({ chargeSubCategoryId });
  if (isLoading) return <Spinner />;
  return (
    <ManageChargeSubCategoryForm
      categoryId={categoryId}
      agentType={agentType}
      chargeSubCategoryId={chargeSubCategoryId}
      data={subCategoryDetail}
    />
  );
};
